const getAmountRemainingToPay = require('./getAmountRemainingToPay')
const formatItems = require('./formatItems')
const helpers = require('./helpers');
const ventilateAmountTotalByTva = require('./ventilateAmountTotalByTva')
const paymentMethods = require('../paymentMethods')
const arePaymentsDone = require('./arePaymentsDone')
const getAmountPaid = require('../paymentMethods/getAmountPaid')


module.exports = Object.assign({
  getAmountRemainingToPay,
  getAmountPaid(params = {}){
    return getAmountPaid({ payments: this.payments, ...params });
  },
  arePaymentsDone({ payments, items, reduced, added, added_reduced }){
    return arePaymentsDone({ 
      payments: payments || this.payments,
      items: items || this.items,
      reduced: reduced || this.reduced,
      added: added || this.added,
      added_reduced: added_reduced || this.added_reduced
    })
  },
  formatItems(params){
    return formatItems(this.items, { type: 'items', ...params });
  },
  formatReducedItems(params){
    return formatItems(this.reduced, { type: 'reduced', ...params });
  },
  formatRemovedItems(params){
    return formatItems(this.removed, { type: 'removed', ...params });
  },
  getUnitsTotal(){
		return helpers.calculateUnitsTotal({ order: this });
	},
	getAmountTotal(tva){
		return helpers.calculateAmountTotal({ order: this, tva });
  },
  getAmountTotalHT(tva){
		return helpers.calculateAmountTotal({ order: this, getHT: true, tva });
  },
  getAmountTotalTVA(tva){
		return helpers.calculateAmountTotal({ order: this, getTVA: true, tva });
  },
  calculateTVARate(){
    return helpers.calculateTVARate({ order: this });
  },
  isPaid(){
    return !!this.paidAt;
  },
  ventilateAmountTotalByTva(){
    return ventilateAmountTotalByTva({
      items: this.items,
      reduced: this.reduced
    })
  }
}, paymentMethods);